module.exports = __webpack_public_path__ + "img/c1.45f59696.jpg";